import { render, staticRenderFns } from "./RentRateForLandList.vue?vue&type=template&id=276077ec&scoped=true&"
import script from "./RentRateForLandList.vue?vue&type=script&lang=js&"
export * from "./RentRateForLandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276077ec",
  null
  
)

export default component.exports